export default __webpack_public_path__ + "static/dont-overflow-0744ca2733a9e93e7f4eb321d2856bf0.png";